import React, { ComponentPropsWithRef, FC, useCallback, useEffect } from 'react'

import clsx from 'clsx'

import { ErrorTxt } from 'src/components/atoms'

type InputProps = ComponentPropsWithRef<'input'>
export type Props = {
  mode?: 'light' | 'dark'
  onEscapeKeyDown?: () => void
  onEnterKeyDown?: () => void
  forwardRef?: React.Ref<HTMLInputElement> | React.ForwardedRef<HTMLInputElement>
  errorMessage?: string
} & InputProps
const BaseSimplePlane: FC<Props> = ({
  mode = 'light',
  onEscapeKeyDown,
  onEnterKeyDown,
  forwardRef,
  errorMessage,
  className,
  ...otherProps
}) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      event.key === 'Escape' && onEscapeKeyDown?.()
      event.key === 'Enter' && !event.isComposing && onEnterKeyDown?.()
    },
    [onEscapeKeyDown, onEnterKeyDown]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false)
    return () => document.removeEventListener('keydown', handleKeyDown, false)
  }, [handleKeyDown])

  return (
    <div className={className}>
      <input
        className={clsx(
          'tw-text-[inherit] tw-caret-correctGreen-default tw-outline-none tw-px-s-5 tw-pb-s-4 tw-w-full placeholder:tw-text-standardText-disable',
          'tw-duration-100 tw-ease-in-out',
          'tw-border-b tw-border-b-border-primary',
          mode === 'light'
            ? 'hover:tw-border-b-roovPrimary-default focus:tw-border-b-roovPrimary-default'
            : 'hover:tw-border-b-inlineText-primary focus:tw-border-b-inlineText-primary',
          errorMessage && '!tw-border-b-errorRed-default'
        )}
        {...otherProps}
        ref={forwardRef}
      />
      {errorMessage && <ErrorTxt text={errorMessage} className="tw-mt-s-4" />}
    </div>
  )
}

export const SimplePlane = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <BaseSimplePlane forwardRef={ref} {...props} />
})
